'use es6';

import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { InputStaticLabel } from 'foundations-components/transitional/components/InputStaticLabel';
import { TimePicker } from 'foundations-components/transitional/components/TimePicker';
import { useControlsContext } from '../context';
import { getEventValue } from '../../../utils/jsEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareScheduleTimePickerSelect = () => {
  const {
    shareScheduleAtHour,
    setShareScheduleAtHour
  } = useControlsContext();
  const getTimezone = () => I18n.moment.portalTz().format('z');
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.scheduleTimeLabel"
    }),
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailScheduleWarningText"
    }),
    required: true,
    children: /*#__PURE__*/_jsx(InputStaticLabel, {
      text: getTimezone(),
      position: "end",
      children: /*#__PURE__*/_jsx(TimePicker, {
        clearable: false,
        interval: 60,
        onChange: e => {
          setShareScheduleAtHour(getEventValue(e) / 60);
        },
        value: shareScheduleAtHour * 60
      })
    })
  });
};
export default ShareScheduleTimePickerSelect;